import React, { useEffect, useState } from "react";
import axios from "axios";
import { Card } from "react-bootstrap";
import PortfolioChart from "./components/PortfolioChart";

const AppMain = () => {
  const [accountInfo, setAccountInfo] = useState({});
  const [positions, setPositions] = useState([]);
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [reloadAPI] = useState(false);

  useEffect(() => {
    const authHeader = "Bearer " + sessionStorage.getItem("jwt");
    setIsLoading(true);
    const instance = axios.create({
      baseURL:
        "https://18z7zyxvn4.execute-api.us-east-2.amazonaws.com/robovest-api",
      headers: {
        Authorization: authHeader,
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
      },
    });

    instance
      .get("")
      .then((res) => {
        console.log(res);
        setAccountInfo(res.data.account);
        setPositions(res.data.positions);
        setOrders(res.data.orders);
        setIsLoading(false);
        sessionStorage.setItem("dbItem", JSON.stringify(res.data));
      })
      .catch((err) => {
        console.log("API Request error:", err);
        console.log("API request error message:", err.message);
        sessionStorage.removeItem("dbItem");
        alert("API request error! Error: " + err.message);
        setIsLoading(false);
      });
  }, [reloadAPI]);

  return (
    <div className="app-main">
      {isLoading ? (
        <div className="spinner-border text-primary m-10" role="status">
          <span className="sr-only"></span>
        </div>
      ) : (
        <>
          <h2 className="display-6 mb-4">Account Dashboard</h2>
          <div className="row">
            <div className="col-sm-4 col-md-4 col-lg-4">
              <Card className="mb-3">
                <Card.Body>
                  <strong>Account Number: </strong>
                  {accountInfo.account_number}
                </Card.Body>
              </Card>

              <Card className="mb-3">
                <Card.Body>
                  <Card.Title>
                    Total Equity: ${(1 * accountInfo.equity).toFixed(2)}
                  </Card.Title>
                  <hr />
                  <Card.Text>
                    <div>
                      <strong>Change: </strong>
                      {accountInfo.equity - accountInfo.last_equity >= 0 ? (
                        <>
                          <i className="bi bi-caret-up-fill text-success" />$
                          {(accountInfo.equity - accountInfo.last_equity).toFixed(2)}
                        </>
                      ) : (
                        <>
                          <i className="bi bi-caret-down-fill text-danger" />$
                          {(accountInfo.equity - accountInfo.last_equity).toFixed(2)}
                        </>
                      )}
                    </div>
                  </Card.Text>

                  <Card.Text>
                    <strong>Position Market Value: </strong>$
                    {accountInfo.position_market_value}
                  </Card.Text>
                  <Card.Text>
                    <strong>Cash: </strong>${accountInfo.cash}
                  </Card.Text>
                </Card.Body>
              </Card>
            </div>
            <div className="col" style={{ minWidth: 0 }}>
              <PortfolioChart />
            </div>
          </div>

          <Card className="mb-4">
            <Card.Body>
              <Card.Title>Open Orders</Card.Title>
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th scope="col">Symbol</th>
                      <th scope="col">Type</th>
                      <th scope="col">Qty</th>
                      <th scope="col">Time in Force</th>
                      <th scope="col">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orders.map((order, index) => (
                      <tr key={index}>
                        <td>{order.symbol}</td>
                        <td>
                          {order.order_type.toUpperCase()}{" "}
                          {order.side.toUpperCase()} @{" "}
                          {order.limit_price}
                        </td>
                        <td>{order.qty}</td>
                        <td>{order.time_in_force.toUpperCase()}</td>
                        <td>{order.status.toUpperCase()}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Card.Body>
          </Card>

          <Card className="mb-4">
            <Card.Body>
              <Card.Title>Positions</Card.Title>
              <hr />
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th scope="col">Symbol</th>
                      <th scope="col">Mkt Value</th>
                      <th scope="col">Qty</th>
                      <th scope="col">Avg Price</th>
                      <th scope="col">Curr Price</th>
                      <th scope="col">P/L $</th>
                      <th scope="col">P/L %</th>
                    </tr>
                  </thead>
                  <tbody>
                    {positions.map((position, index) => (
                      <tr key={index}>
                        <td>{position.symbol}</td>
                        <td>{(1 * position.market_value).toFixed(2)}</td>
                        <td>{position.qty}</td>
                        <td>{position.avg_entry_price}</td>
                        <td>{position.current_price}</td>
                        <td className={position.unrealized_pl < 0 ? "text-danger" : "text-success"}>
                          {position.unrealized_pl < 0 ? (
                            <i className="bi bi-caret-down-fill" />
                          ) : (
                            <i className="bi bi-caret-up-fill" />
                          )}
                          {(1 * position.unrealized_pl).toFixed(2)}
                        </td>
                        <td className={position.unrealized_plpc < 0 ? "text-danger" : "text-success"}>
                          {position.unrealized_plpc < 0 ? (
                            <i className="bi bi-caret-down-fill" />
                          ) : (
                            <i className="bi bi-caret-up-fill" />
                          )}
                          {(100 * position.unrealized_plpc).toFixed(2)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Card.Body>
          </Card>

        </>
      )}
    </div>
  );
};

export default AppMain;
